import React, {useState} from 'react';
import './styles/sidebar.css';
import { NavLink } from "react-router-dom";
import ToggleSideBar from './ToggleSideBar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown, faAngleUp, faHouseChimney, faUser, faLandmark, faBoxesStacked, faHammer, faRoute} from '@fortawesome/free-solid-svg-icons';
import { motion } from 'framer-motion';

export default function Sidebar({toggleInfo, onToggle}) {

    const [invToggler, setInvToggler] = useState(false);
    const [wToggler, setWToggler] = useState(false);
    const [eToggler, setEToggler] = useState(false);


    const togglerInv = () =>{
        setInvToggler(!invToggler);
    }

    const togglerW = () =>{
        setWToggler(!wToggler);
    }

  return (
    <div className={toggleInfo ? 'sidebar-box' : 'sidebar-box sidecollapse'}
    >
        {toggleInfo
            ? <nav className='my-3'>
            <span className='ms-2'><ToggleSideBar info={toggleInfo} changeState={onToggle}/></span>
            <ul className='nav navshow mx-4'>
                <NavLink to="/" className={({isActive}) => 'sidebar-items' + (isActive ? ' active-items' : '')} >
                    <span><FontAwesomeIcon icon={faHouseChimney} className='icon-item'/>HOME</span>
                </NavLink>
                <NavLink to="/profile"  className={({isActive}) => 'sidebar-items' + (isActive ? ' active-items' : '')}>
                    <span><FontAwesomeIcon icon={faUser} className='icon-item'/>MY ACCOUNT</span>
                </NavLink>
                <NavLink to="/bank" className={({isActive}) => 'sidebar-items' + (isActive ? ' active-items' : '')}>
                    <span><FontAwesomeIcon icon={faLandmark} className='icon-item'/>COUNCIL BANK</span>
                </NavLink>
                {invToggler
                    ? <button className='btn-togglerInv toggler-active' onClick={() => togglerInv()}> <FontAwesomeIcon icon={faBoxesStacked} className='icon-item'/>INVENTORY<FontAwesomeIcon icon={faAngleUp} className='icon-toggler'/></button>
                    : <button className='btn-togglerInv' onClick={() => togglerInv()}><FontAwesomeIcon icon={faBoxesStacked} className='icon-item'/>INVENTORY<FontAwesomeIcon icon={faAngleDown} className='icon-toggler'/></button>
                }
                {invToggler &&
                    <div className='d-flex flex-column align-items-start box-inv'>
                        <NavLink to="/inventory/suits" className={({isActive}) => 'subItems pt-2' + (isActive ? ' active-subitem' : '')}>
                            <span>SUITS</span>
                        </NavLink>
                        <NavLink to="/inventory/weapons"className={({isActive}) => 'subItems' + (isActive ? ' active-subitem' : '')}>
                            <span>WEAPONS & EQUIPMENT</span>
                        </NavLink>
                        <NavLink to="/inventory/bperks" className={({isActive}) => 'subItems' + (isActive ? ' active-subitem' : '')}>
                            <span>BLUEPRINTS & PERKS</span>
                        </NavLink>
                        <NavLink to="/inventory/special-items" className={({isActive}) => 'subItems' + (isActive ? ' active-subitem' : '')}>
                            <span>SPECIAL ITEMS</span>
                        </NavLink>
                    </div> 
                }
                {wToggler
                    ? <button className='btn-togglerInv toggler-active' onClick={() => togglerW()}><FontAwesomeIcon icon={faHammer} className='icon-item'/>WORKSHOPS<FontAwesomeIcon icon={faAngleUp} className='icon-toggler'/></button>
                    : <button className='btn-togglerInv' onClick={() => togglerW()}><FontAwesomeIcon icon={faHammer} className='icon-item'/>WORKSHOPS<FontAwesomeIcon icon={faAngleDown} className='icon-toggler'/></button>
                }
                {wToggler &&
                    <div className='d-flex flex-column align-items-start box-inv'>
                        <NavLink to="/workshops/scrapyard" className={({isActive}) => 'subItems pt-2' + (isActive ? ' active-subitem' : '')}>
                            <span>SCRAPYARD</span>
                        </NavLink>
                        <NavLink to="/workshops/alchemist" className={({isActive}) => 'subItems' + (isActive ? ' active-subitem' : '')}>
                            <span>ALCHEMIST</span>
                        </NavLink>
                        <NavLink to="/workshops/billysworkshop" className={({isActive}) => 'subItems' + (isActive ? ' active-subitem' : '')}>
                            <span>BILLY'S WORKSHOP</span>
                        </NavLink>
                    </div> 
                }
                <NavLink to="/expeditions"  className={({isActive}) => 'sidebar-items' + (isActive ? ' active-items' : '')}>
                    <span><FontAwesomeIcon icon={faRoute} className='icon-item'/>EXPEDITIONS</span>
                </NavLink>
            </ul>
        </nav>
            : <nav className='d-flex nav-box'>
                    <span><ToggleSideBar  info={toggleInfo} changeState={onToggle}/></span>
                    <ul className='nav navcollap'>
                        <NavLink to="/" className={({isActive}) => 'sidebar-items-collap' + (isActive ? ' active-items-collap' : '')} >
                            <span><FontAwesomeIcon icon={faHouseChimney}/></span>
                        </NavLink>
                        <NavLink to="/profile"  className={({isActive}) => 'sidebar-items-collap' + (isActive ? ' active-items-collap' : '')}>
                            <FontAwesomeIcon icon={faUser}/>
                        </NavLink>
                        <NavLink to="/bank" className={({isActive}) => 'sidebar-items-collap' + (isActive ? ' active-items-collap' : '')}>
                            <span><FontAwesomeIcon icon={faLandmark}/></span>
                        </NavLink>
                        <NavLink to="/inventory"  className={({isActive}) => 'sidebar-items-collap' + (isActive ? ' active-items-collap' : '')}>
                            <span><FontAwesomeIcon icon={faBoxesStacked}/></span>
                        </NavLink>
                        <NavLink to="/workshops"  className={({isActive}) => 'sidebar-items-collap' + (isActive ? ' active-items-collap' : '')}>
                            <span><FontAwesomeIcon icon={faHammer}/></span>
                        </NavLink>
                        <NavLink to="/expeditions"  className={({isActive}) => 'sidebar-items-collap' + (isActive ? ' active-items-collap' : '')}>
                            <span><FontAwesomeIcon icon={faRoute}/></span>
                        </NavLink>
                    </ul>
                </nav>
        }
    </div>
  )
}